import { EN, VI, initI18n } from "@humanex/ui/libs";

import { AppCfg } from "@/configs/app";

// Import translation files
import en from "./locales/en.json";
import vi from "./locales/vi.json";

// Initialize i18n with app-specific translations
initI18n({
  resources: {
    en: {
      ...EN,
      ...en
    },
    vi: {
      ...VI,
      ...vi
    }
  },
  defaultLanguage: "vi",
  fallbackLanguage: "vi",
  debug: !AppCfg.isProd
});
